import { useTranslations } from "use-intl";
import { BaseEnumResolver, BaseEnumResolverProps } from "./BaseEnumResolver";
export const NotificationTypeResolver = (props: Omit<BaseEnumResolverProps, "type">) => {
  const t = useTranslations();
  return <BaseEnumResolver {...props} placeholder={t("placeholder_chooseNotificationType_20230807143006")} options={[{
    value: "PROCEDURE_FINISHED",
    label: "Procedure Finished"
  }, {
    value: "PROCEDURE_STARTED",
    label: "Procedure Started"
  }]} useToggleForTwoOptions data-sentry-element="BaseEnumResolver" data-sentry-component="NotificationTypeResolver" data-sentry-source-file="NotificationTypeResolver.tsx" />;
};